module.exports = __webpack_public_path__ + "static/media/logo-footer.a3b21795.svg";